import Block from "base/Block";

class PageMenuNav extends Block {
	static get blockName() {
		return 'b-page-menu-nav';
	}

	onInit() {
		let navItems = this.el.querySelectorAll('.' + this.blockName + '__item');
		this.pageMenu = document.querySelector('.b-page-menu');
		this.navContainer = this.pageMenu.querySelector('.b-page-menu__bottom');

		if (navItems) {
			const paddingTop = 24;

			navItems.forEach(navItem => {
				let navItemLink = navItem.querySelector('.' + this.blockName + '__item-link');

				if (navItemLink.getAttribute('data-has-listener') == "false") {
					navItemLink.addEventListener('click', (e) => {
						e.preventDefault();
						this.scrollToElement(navItemLink);
					});

					navItemLink.setAttribute('data-has-listener', 'true');
				}

				if (navItem.classList.contains(this.blockName + '__item--parent')) {
					let navItemName = navItem.querySelector('.' + this.blockName + '__item-name');
					let subItem = navItem.querySelector('.' + this.blockName + '__subitems');
					subItem.style.maxHeight = 0;

					navItemName.addEventListener('click', (event) => {
						if (!event.target.classList.contains(this.blockName + '__item-link')) {
							if (navItem.classList.contains('open')) {
								navItem.classList.remove('open');
								subItem.style.maxHeight = 0;
							} else {
								navItem.classList.add('open');
								subItem.style.maxHeight = subItem.scrollHeight + 'px';
								this.navContainer.style.maxHeight = paddingTop + subItem.scrollHeight + +this.navContainer.scrollHeight + 'px';
							}
						}
					});

					let subItemLinks = navItem.querySelectorAll('.' + this.blockName + '__subitem a');
					subItemLinks.forEach(subItemLink => {
						subItemLink.addEventListener('click', (e) => {
							e.preventDefault();
							this.scrollToElement(subItemLink);
						});
					});
				}
			});
		}
	}

	scrollToElement(link) {
		this.pageMenu.classList.remove('open');
		this.navContainer.style.maxHeight = 0;
		let blockId = (link.getAttribute('href')).slice(1);
		let block = document.getElementById(blockId);

		if (!block.classList.contains('s-m-t-280')) {
			block.classList.add('s-m-t-280');
		}

		block.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
		});
	}
}

Block.register(PageMenuNav);

export default PageMenuNav;
